export default {
  apiKey: "AIzaSyB8-wy0DJ-w95vCGoMbEbpn0jVmX4IxHoQ",
  discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
  //spreadsheetId: "12K-dZ5_FnyVbcPrqWmjDDBodOyKIJ1Zi_EOaXCTz2G0"
  //spreadsheetId: "1nWVIVz4Nj3oJSq2Ch0WmX_WbRf7j2qbWb8CkghdiTEM" //18-19
  // spreadsheetId: "168G9srsw3-Y1q2Yv5jvw6CWlrDLK1vRW7TgEEPAfSL0", //19-20
  // spreadsheetId: "1CxEaDd-Ds1JkNA-uXK5GPqt7c_rjZOd27Y2CnOysej4", // 21-22
  // spreadsheetId: "1L32WTQwyfgILGq25WXU23_G3iqFmFbIWpuTJMii-2V8", // 22-23
  // spreadsheetId: "1g5nQ_dvWMBnKbuJ1N8-Xc1ADn5MR-v5VzYpdOtTDVak", // 23-24
  // spreadsheetId: "17g4GmDFrEwzlXBOJ6Qtsp5sThsQkr6ZGw0uOIiQtlQU", // 24-25
  spreadsheetId: "157PPm3_jPubSwn-JJ3UZ7D7YNyp3E6Lip_SIRf2UwH0", // 25-26
  // gameScheduleSheetId: "1I2UD_pn8ivV_rGB7LC31VJIHL2WMiU9E8gFjCKjc3kw", //21-22
  // gameScheduleSheetId: "11eb92qvrFCsEPT_pK1LujAGj2GZh7bMEMKWT_Sew31A", // 22-23
  // gameScheduleSheetId: "1u4q2-fuGSb0suGbWL3XMbtWEpKGY8MnpMcdeyuwdHd0", // 23-24
  // gameScheduleSheetId: "1pm6fwvrWfftgx_2UQ4XPDU4e6OQe25-aO8nUfyf-cic", // 24 - 25
  gameScheduleSheetId: "1BDA199sG2-DB4D-Ge9lSNNzSJqCSSRLQfeYfquDGlko", // 25 - 26
};
